'use client';

import {styled} from '@mui/material/styles';
import type {ReactNode} from 'react';

import {FieldHelperText} from './FieldHelperText';
import {FieldLabel} from './FieldLabel';

const Root = styled('div')({display: 'flex', flexDirection: 'column', width: '100%'});
const Shell = styled('div')({position: 'relative', width: '100%'});

export interface FieldShellProps {
  label: string;
  required?: boolean;
  showLabel: boolean;
  labelAlign?: 'center' | 'top';
  helperId?: string;
  error?: boolean;
  helperText?: string;
  counter?: string;
  children: ReactNode;
}

export function FieldShell({label, required, showLabel, labelAlign, helperId, error, helperText, counter, children}: FieldShellProps) {
  return (
    <Root>
      <Shell>
        {children}
        {showLabel && <FieldLabel label={label} required={required} align={labelAlign} />}
      </Shell>
      <FieldHelperText id={helperId} error={error} message={helperText} counter={counter} />
    </Root>
  );
}

FieldShell.displayName = 'FieldShell';
